import React from "react";
import { Input, Modal, Form, Col } from "antd";
import { ICourtCase } from "../../model/CourtCase";
import { TTranslate } from "../../../core/service/locale/TranslationService";
import { ICasePhase } from "../../model/CasePhase";
import { ICaseDecision } from "../../../caseDecisions/model/CaseDecision";
import { IIndexTypeAttribute } from "../../../indexTypes/model/IndexTypeAttribute";
import { IIndexAttributeData } from "../../../indexTypes/model/IndexAttributeData";
import { IOrganisationIndex } from "../../../organisations/model/OrganisationIndex";

export interface Props {
  courtCase?: ICourtCase;
  translate: TTranslate;
  indexTypeAttributes?: IIndexTypeAttribute[];
  indexAttributeDataList?: IIndexAttributeData[];
  setAttributesData: any;
  indexDataModalVisible: boolean;
  closeIndexDataModal: any;
  saveAttributeData: any;
  selectedIndexForAttribute: IOrganisationIndex;
  form: any;
}

export type TCourtPhaseSelectionModel = {
  phase: ICasePhase;
  caseDecision?: ICaseDecision;
  connectionTypeId: number;
};
export interface State {
  selectedCourtPhases?: TCourtPhaseSelectionModel[];
  selectedCaseDecision?: ICaseDecision;
  selectedConnectedDecisions?: { [courtCaseNumber: string]: ICaseDecision };
}
export default class IndexAttributeDataForm extends React.Component<
  Props,
  State
> {
  constructor(props) {
    super(props);
    this.state = {
      selectedCourtPhases: []
    };
  }

  renderIndexTypeAttributes() {
    return this.props.indexTypeAttributes?.map((item) => {
      let indexAttributeData = this.props.indexAttributeDataList?.find(
        (d) => d.indexTypeAttributeId === item.id
      );
      return (
        <div>
          <div style={{ display: "flex" }}>
            <div>
              {item.required ? (
                <div style={{ color: "red", marginRight: "0.1em" }}>*</div>
              ) : (
                <div></div>
              )}
            </div>
            <div style={{ width: "5em" }}>{item.attribute}</div>
          </div>
          <Form.Item
            initialValue={indexAttributeData?.attributeData}
            name={indexAttributeData?.attributeData}
            rules={[
              {
                required: item.required,
                message: this.props.translate(
                  "editors.case_law_document_types.required_messages"
                )
              }
            ]}
          >
            <Input
              onBlur={(e) => {
                this.props.setAttributesData(item, e.currentTarget.value);
                e.preventDefault();
              }}
            />
          </Form.Item>
          <Col
            span={2}
            style={{
              display: "flex",
              marginTop: 10,
              alignItems: "center"
            }}
          ></Col>
        </div>
      );
    });
  }

  render() {
    const {
      translate,
      indexDataModalVisible,
      closeIndexDataModal,
      saveAttributeData,
      indexTypeAttributes,
      selectedIndexForAttribute
    } = this.props;
    return (
      <Modal
        visible={indexDataModalVisible}
        title={selectedIndexForAttribute?.name}
        okText={translate("modal_functions.insert_modal.add")}
        cancelText={translate("modal_functions.insert_modal.cancel")}
        onCancel={() => closeIndexDataModal(false)}
        onOk={saveAttributeData}
      >
        {indexTypeAttributes && (
          <Col xs={24} sm={24}>
            <div style={{ fontWeight: "bold", marginBottom: "1em" }}>
              {translate("editors.organisation_indexes.attributes")}
            </div>
            {this.renderIndexTypeAttributes()}
          </Col>
        )}
      </Modal>
    );
  }
}
